import { useSearchParams } from '@/hooks/useSearchParams';
import { Nullable } from '@starsoft/common/interfaces';
import { parseToBigInt } from '@starsoft/common/utils/parsers';
import { GameReportType } from './gameReportType.enum';
import { UseGameReportSearchParamsReturn } from './props';

export function useGameReportSearchParams(): UseGameReportSearchParamsReturn {
  const search = useSearchParams();
  const roundSlug = search.get('round-slug');
  const roundId = search.get('round-id');
  const betSlug = search.get('bet-slug');
  const gameId = search.get('game-id');
  const type = search.get('game-type') as Nullable<GameReportType>;

  const defaultReturn: UseGameReportSearchParamsReturn = {
    type,
    roundSlug,
    roundId,
    betSlug,
    gameId: gameId ? (parseToBigInt(gameId) as bigint) : undefined,
  };

  return defaultReturn;
}
